import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from "lodash";

export class PlanningProjectsTableRowCtrl implements IController {
  projectId: any;
  onDelete: Function;


  project: any;

  /* @ngInject */
  constructor(private $planningProjects, private $scope: IScope, private planningConstants, private $state) {
  }

  $onInit() {
    if (this.projectId) {
      this.$planningProjects(this.projectId).$bindCtrlToId(this.$scope, this, 'project', 'projectId');
    }
  }

  $onChanges(onChangesObj: angular.IOnChangesObject) {
    if (onChangesObj.projectId && !onChangesObj.projectId.isFirstChange()) {
      this.$onInit();
    }
  }

  onGoToProject() {
    if (_.get(this.project, 'status') === 'DISPATCHED') {
      this.$state.go(this.planningConstants.states.completed, {
        projectId: this.project.id,
        draftId: this.project.selectedDraftId
      }, {notify: true, reload: false});
    } else if (_.get(this.project, 'selectedDraftId')) {
      this.$state.go(this.planningConstants.states.draft, {
        projectId: this.project.id,
        draftId: this.project.selectedDraftId
      }, {notify: true, reload: false});
    } else {
      this.$state.go(this.planningConstants.states.project, {
        projectId: this.project.id,
        draftId: undefined
      }, {notify: true, reload: false});
    }
  }


}

angular
  .module('bringoz.admin.planning')
  .component('planningProjectsTableRow', {
    bindings: {
      projectId: '<',
      onDelete: '&'
    },
    template: require('./planning-projects-table-row.html').default,
    controller: PlanningProjectsTableRowCtrl
  });
